import axios from 'axios'
import api from './api'
import Vue from 'vue';
import router from '../router'
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);
//创建axios实例对象
const  instance = axios.create({
    // 同域相对路径：各站点 nginx 把 /api 反代到后端（tx1/love-u 均配了
    // proxy_pass https://sz.love-u.xyz），前端包放任何域都自动同域，免跨域
    baseURL: 'https://love-u.xyz/api', //服务器地址
    timeout: 5000, //默认超时时长
})

//请求拦截器
instance.interceptors.request.use(config=>{
    config.headers = Object.assign({}, config.headers, { 'Lang': localStorage.getItem('lang') || 'en-US' })
    if (localStorage.getItem('token')) {
        config.headers['token'] = Base64.encode(localStorage.getItem('token'))
    }
    if (config.data instanceof FormData) {
      // 文件上传：axios 会自动设带 boundary 的 multipart 头，任何手动 content-type
      // 都会破坏边界（服务端收不到文件）。跳过默认的 urlencoded 强制。
      // 注意：本分支必须在 headers 合并与 token 注入之后，保证上传请求同样带 Lang/token 头。
      return config
    }
    if (config.method === 'post' && !config.headers['content-type']) {
        config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    }
    return config
},err=>{
    console.error('请求失败', err)
})

//响应拦截器：token 失效按专用码 4011 判断（后端 18 处鉴权错误出口专用；业务校验错误仍是 401，由各页面 toast，不触发登出）
instance.interceptors.response.use(res=>{
    if (res.data && res.data.code === 4011 && localStorage.getItem('token')) {
        localStorage.removeItem('token')
        router.push({ path: '/Login' })
    }
    return res
},err=>{
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求；FormData（文件上传）直接透传，qs.stringify 会把 FormData 打空
        const body = option.data instanceof FormData ? option.data : qs.stringify(option.data)
        await instance[option.method](
                api[option.url],
            body,
            option.timeout ? { timeout: option.timeout } : undefined
        ).then(res=>{
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export default http

